import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 10l0 10","key":"svg-0"}],["path",{"d":"M12 10l4 4","key":"svg-1"}],["path",{"d":"M12 10l-4 4","key":"svg-2"}],["path",{"d":"M4 4l16 0","key":"svg-3"}]]

const IconArrowBarToUp = createReactComponent('outline', 'arrow-bar-to-up', 'ArrowBarToUp', __iconNode);

export default IconArrowBarToUp;